module.exports = __webpack_public_path__ + "media/images/lp_consultation/correlation-diagram-device-small-9ba5f4e423c9110fee938d41ee3e0ee7.png";